/* eslint-disable @typescript-eslint/no-explicit-any */
import { BASE_DATA_STORAGE_KEY } from '../constants';
import { KUxAnalyticsPlugin } from '../interfaces';
import { AnalyticsError, ErrorCodes } from '../interfaces/errors';
import { KUxBaseEventData } from '../interfaces/events';
import { convertTimestampToSeconds, generateTimestamp } from '../utils/date';

export class PpfDataLake implements KUxAnalyticsPlugin {
  static pluginName = 'ppf-datalake';
  config;
  name = PpfDataLake.pluginName;

  constructor(config: { endpointUrl: string }) {
    if (!config.endpointUrl) {
      throw new AnalyticsError(ErrorCodes.missingPluginEndpointUrl);
    }
    this.config = config;
  }

  async send(data: Record<string, any>) {
    const path = data.event.path;
    delete data.event.path;
    delete data.ks;
    const url = `${this.config.endpointUrl}/${path}`;

    try {
      const res = await fetch(url, {
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return await res.json();
    } catch (e) {
      console.warn(e);

      throw e;
    }
  }

  initialize({ config }: any) {
    // load provider script to page
  }

  page({ payload }: any) {
    // call provider specific page tracking
  }

  track = async ({ payload, config, instance }: any) => {
    // get base data from analytics storage
    const baseData: KUxBaseEventData = instance.storage.getItem(BASE_DATA_STORAGE_KEY);
    const timestamp = generateTimestamp();
    // set auto properties data in base obj
    baseData.timestamp = convertTimestampToSeconds(timestamp);
    // delete payload.properties.name;
    const event = Object.assign({}, payload.properties.event);

    // merge payload data with base data
    const fullPayloadData = { ...baseData, sequenceId: payload.properties.sequenceId, event, appData: config.appData };
    try {
      await this.send(fullPayloadData);
    } catch (e) {
      if (payload.options.errCallback) {
        payload.options.errCallback(e);
      }
    }
  };

  identify({ payload }: any) {
    // call provider specific user identify method
  }

  loaded() {
    // return boolean so analytics knows when it can send data to third-party
    return true;
    // return !!window.myPluginLoaded;
  }
}
